import { render, staticRenderFns } from "./AddOutsourcing.vue?vue&type=template&id=a4f5c47c&"
import script from "./AddOutsourcing.vue?vue&type=script&lang=js&"
export * from "./AddOutsourcing.vue?vue&type=script&lang=js&"
import style0 from "./AddOutsourcing.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports